export default __webpack_public_path__ + "static/media/5.ceaaab4b.webp";